import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import {
  Button,
  Typography,
  Toolbar,
  Dialog,
  Slide,
  IconButton,
  AppBar,
  ButtonGroup,
  Grid,
  Box,
  Modal,
  Tooltip,
  FormControlLabel,
  Checkbox,
  MenuItem,
  TextField,
} from '@mui/material';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import InputField from '../../../reusable-component/InputField';
import LoadingIcon from '../../../reusable-component/LoadingIcon';

const styleLoading = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
};

const nameRegex = /^[a-zA-Z0-9_]{1,35}$/;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const INITIALSTATE = {
  alias: '',
  df: '',
  addition_columns_array: [
    {
      colName: '',
      colValue: '',
      colType: '',
    },
  ],
  sample_view: 'true',
};

const getDefaultValueForType = (colType) => {
  switch (colType) {
    case 'integer':
    case 'long':
      return '0';
    case 'float':
    case 'double':
      return '0.0';
    case 'boolean':
      return 'false';
    case 'date':
      return dayjs().format('YYYY-MM-DD');
    case 'timestamp':
      return dayjs().format('YYYY-MM-DD HH:mm:ss');
    case 'string':
    default:
      return '';
  }
};

const NodeModal_AddColumn = ({
  nodeId,
  nodeName,
  handleClose,
  open,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  workflow,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const [aliasError, setAliasError] = useState('');
  const [headers, setHeaders] = useState([]);

  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);

  const store = JSON.parse(sessionStorage.getItem('allNodes'));
  let newHeader = [];

  const getLocalData = async () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
          }
        });
      });
      setFormField({ ...formField, df: prev_alias });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      newHeader = uniqueArray.map((el) => {
        return {
          ...el,
          header: el.alias ? el.alias : el.header,
          alias: el.alias ? '' : el.alias,
        };
      });

      const head = [];
      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });
      setHeaders(head);
      setFetchedHeader(newHeader);

      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getLocalData();
  }, [nodeId]);

  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

    const findSrcNodeId = [];

    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);

      enqueueSnackbar('No source node is connected !!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }

      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const newHeader = uniqueArray.map((el) => ({
        ...el,
        header: el.alias ? el.alias : el.header,
        alias: el.alias ? '' : el.alias,
      }));

      if (nodesExist) {
        store.forEach((node) => {
          if (node.nodeId === nodeId) {
            setFormField(node.formField);
            setHeaderName(node.headerName);

            const nonExistingHeader = [];
            node.fetchedHeader.forEach((item) => {
              const index = newHeader.findIndex((x) => x.header === item.header);

              if (index !== -1) {
                nonExistingHeader.push(item);
              }
            });

            newHeader.forEach((el) => {
              const index = nonExistingHeader.findIndex((x) => x.header === el.header);

              if (index === -1) {
                nonExistingHeader.push({
                  ...el,
                  header: el.alias ? el.alias : el.header,
                  alias: el.alias ? '' : el.alias,
                });
              }
            });

            const head = [];

            newHeader.forEach((el) => {
              head.push({ label: el.header });
            });

            setHeaders(head);

            setFetchedHeader(nonExistingHeader);
          }
        });
      } else {
        setFetchedHeader(newHeader);
      }
    }
    enqueueSnackbar('Data Refreshed!!!', {
      variant: 'Success',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
    handleRefreshModalClose();
  };

  const handleInputChange = (e, index, key) => {
    const { name, value } = e.target;
    if (name === 'alias') {
      if (value && !nameRegex.test(value)) {
        setAliasError('Special characters are not allowed');
      } else {
        setAliasError('');
      }
    }
    setFormField((prev) => ({
      ...prev,
      [name]: value,
      addition_columns_array: prev.addition_columns_array.map((col, i) =>
        i === index
          ? {
              ...col,
              [key]:
                key === 'colValue'
                  ? col.colType === 'boolean'
                    ? value
                    : ['integer', 'float', 'long', 'double'].includes(col.colType)
                    ? value.replace(/[^0-9.-]/g, '')
                    : col.colType === 'date' || col.colType === 'timestamp'
                    ? value
                    : value
                  : value,
            }
          : col
      ),
    }));
  };
  const addFields = () => {
    setFormField((prev) => ({
      ...prev,
      addition_columns_array: [...prev.addition_columns_array, { colName: '', colType: '', colValue: '' }],
    }));
  };

  const handleDeleteColumn = (index) => {
    setFormField((prev) => ({
      ...prev,
      addition_columns_array: prev.addition_columns_array.filter((_, i) => i !== index),
    }));
  };

  const handleResetForm = async () => {
    setFormField(INITIALSTATE);
    setHeaderName([]);
    setFetchedHeader([]);
    setTempHeader([]);
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    if (aliasError) return;

    const addColumnList = formField.addition_columns_array
      .filter((col) => col.colName.trim() !== '')
      .map((col) => ({
        header: col.colName || '',
        alias: '',
        attribute_type: 'static',
        checked: 'true',
        colValue: col.colValue || getDefaultValueForType(col.colType),
        cast_datatype: col.colType || 'string',
      }));

    if (formField.addition_columns_array.some((col) => col.colName.trim() === '')) {
      enqueueSnackbar("Column name can't be empty !", { variant: 'error' });
      return;
    }

    if (formField.addition_columns_array.some((col) => col.colType.trim() === '')) {
      enqueueSnackbar('Please select data type !', { variant: 'error' });
      return;
    }

    if (!formField?.addition_columns_array || formField.addition_columns_array.length <= 0) {
      enqueueSnackbar('Please add atleast one column', { variant: 'error' });
      return;
    } 

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    templateData.map((item) => {
      newHeaderName.push({
        header: item.fieldname,
        addition_columns_array: formField.addition_columns_array,
        alias: '',
        checked: '',
        tableAlias: formField.alias,
      });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setFetchedHeader((prevFetchedHeader) => [...prevFetchedHeader, ...addColumnList]);
    setHeaderName(newHeaderName);
    const sendFormData = {
      nodeId,
      nodeName,
      formField: { ...formField },
      disabled: true,
      step_name: nodeName,
      y_axis,
      headerName: [...fetchedHeader, ...addColumnList],
      fetchedHeader: [...fetchedHeader, ...addColumnList],
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);
    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  return (
    <div>
      <Dialog fullScreen open={open} TransitionComponent={Transition} style={{ width: '70%', marginLeft: '30%' }}>
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {nodeName}
              </Typography>
              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  disabled={disableForm}
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: '#00043C' }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button size="small" variant="outlined" className="outlined-button-color" onClick={handleEdit}>
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>

          <div style={{ margin: '20px' }}>
            <Grid container spacing={2}>
              <Box sx={{ '& > :not(style)': { m: 2, width: '32ch' } }}>
                <InputField
                  name="alias"
                  label="Alias"
                  value={formField?.alias || ''}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  required
                  error={!!aliasError}
                  helperText={aliasError}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={formField?.sample_view}
                      onChange={handleChecked}
                      disabled={disableForm}
                    />
                  }
                  label="Sample View"
                  sx={{ pl: 1 }}
                />
              </Box>
            </Grid>
            {formField.addition_columns_array &&
              Array.isArray(formField.addition_columns_array) &&
              formField.addition_columns_array.map((col, index) => (
                <Box
                  style={{
                    margin: '20px 0',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                  }}
                  key={index}
                >
                  <Box sx={{ '& > :not(style)': { width: '25ch' } }}>
                    <InputField
                      name="colName"
                      label="Column Name"
                      value={col.colName}
                      onChange={(e) => handleInputChange(e, index, 'colName')}
                      size="small"
                      disabled={disableForm}
                    />
                  </Box>
                  <Box mt={2}>
                    <TextField
                      id="outlined-select-currency"
                      select
                      label="Data Type"
                      size="small"
                      value={col.colType || ''}
                      onChange={(e) => handleInputChange(e, index, 'colType')}
                      disabled={disableForm}
                      sx={{ width: '25ch' }}
                    >
                      <MenuItem value="integer">Number</MenuItem>
                      <MenuItem value="float">Float</MenuItem>
                      <MenuItem value="string">String</MenuItem>
                      <MenuItem value="long">Long</MenuItem>
                      <MenuItem value="double">Double</MenuItem>
                      <MenuItem value="boolean">Boolean</MenuItem>
                      <MenuItem value="date">Date</MenuItem>
                      <MenuItem value="timestamp">Timestamp</MenuItem>
                    </TextField>
                  </Box>
                  <Box sx={{ '& > :not(style)': { width: '25ch' } }}>
                    {col.colType === 'boolean' ? (
                      <TextField
                        select
                        label="Default Value"
                        size="small"
                        value={col.colValue || ''}
                        onChange={(e) => handleInputChange(e, index, 'colValue')}
                        disabled={disableForm}
                      >
                        <MenuItem value="true">True</MenuItem>
                        <MenuItem value="false">False</MenuItem>
                      </TextField>
                    ) : col.colType === 'date' ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Select Date"
                          value={col.colValue ? dayjs(col.colValue) : null}
                          onChange={(newValue) =>
                            handleInputChange({ target: { value: newValue?.format('YYYY-MM-DD') } }, index, 'colValue')
                          }
                          renderInput={(params) => <TextField {...params} />}
                          disabled={disableForm}
                        />
                      </LocalizationProvider>
                    ) : col.colType === 'timestamp' ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          label="Select Timestamp"
                          value={col.colValue ? dayjs(col.colValue) : null}
                          onChange={(newValue) =>
                            handleInputChange(
                              { target: { value: newValue?.format('YYYY-MM-DD HH:mm:ss') } },
                              index,
                              'colValue'
                            )
                          }
                          renderInput={(params) => <TextField {...params} />}
                          disabled={disableForm}
                        />
                      </LocalizationProvider>
                    ) : (
                      <InputField
                        name="colValue"
                        label="Default Value"
                        value={col.colValue}
                        onChange={(e) => handleInputChange(e, index, 'colValue')}
                        size="small"
                        disabled={disableForm}
                        type={['integer', 'float', 'long', 'double'].includes(col.colType) ? 'number' : 'text'}
                      />
                    )}
                  </Box>

                  <IconButton onClick={() => handleDeleteColumn(index)} disabled={disableForm}>
                    <DeleteIcon color="error" />
                  </IconButton>
                </Box>
              ))}

            <Box
              style={{ marginBottom: '30px', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}
            >
              <Button
                disabled={disableForm}
                variant="outlined"
                startIcon={<AddCircleOutlineIcon />}
                onClick={addFields}
              >
                Add Columns
              </Button>
            </Box>
          </div>
        </form>
      </Dialog>
      <Modal open={refreshModalOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
};

export default NodeModal_AddColumn;
